import React from 'react';

const ButtonRegular = ({ 
  children, 
  onClick, 
  className = '', 
  disabled = false,
  type = 'button',
  href,
  target,
  rel,
  ...props 
}) => {
  const baseClasses = 'btn-link';
  const combinedClasses = `${baseClasses} ${className}`.trim();

  // If href is provided, render as anchor tag
  if (href) {
    return (
      <a
        href={href}
        className={combinedClasses}
        onClick={onClick}
        target={target}
        rel={rel}
        {...props}
      >
        {children}
      </a>
    );
  }

  // Otherwise render as button
  return (
    <button
      type={type}
      className={combinedClasses}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default ButtonRegular;
